define('appkit/adapter/param',[ 
  'underscore',
  'backbone'
], function(_, Backbone) {

  function Adapter(model, options) {
    this.model = model;
    this.options = _.extend({}, _.result(this, 'options'), options);
  };

  Adapter.extend = Backbone.View.extend;

  _.extend(Adapter.prototype, {

    serializeFilter: function() {
      return this.model.toJSON();
    },

    setup: function(collection) {
      if (this.options.autoFetch === true) {
        collection.once('request', function() {
          this.model.on('change', _.debounce(function() { collection.fetch(); }, 1));
        }, this)
      }
    },

    preprocess: function(options) {
      options.data = _.extend({}, this.serializeFilter(), options.data);
    }

  });

  return Adapter;
});
